import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { LoggingMiddleware } from "../services/Middleware/LoggingMiddleware"


let redux_devtools = require("redux-devtools");
declare var window: any;

let middlewares = applyMiddleware(
  thunkMiddleware as any,
  LoggingMiddleware
);


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
  middlewares,   
  redux_devtools.persistState(window.location.href.match(/[?&]debug_session=([^&#]+)\b/))
);

export default function(initialState, reducers) {
  const store = createStore(reducers, initialState, enhancer);

  if ((module as any).hot) {
    (module as any).hot.accept("./Reducers", () => store.replaceReducer(require("./Reducers").default));
  }

  return store;
}
